function filterTableStockInventory(table, elementType, elementCat, elementZone, elementStock, column, all = false) {
  var input, filterType, filterCat, filterZone, filterStock, table, tr, td, tdT, tdC, tdZ, tdK, cell, i, j;
  filterType = elementType
  filterCat = elementCat
  filterZone = elementZone
  filterStock = elementStock
  table = table;
  tr = table.getElementsByTagName("tr");

  if (all) {
    for (i = 1; i < tr.length; i++) {
      tr[i].style.display = "";
    }
  } else {
    for (i = 1; i < tr.length; i++) {
      td = tr[i].getElementsByTagName("td")[column];

      //Type is at index 0
      tdT = tr[i].getElementsByTagName("td")[0];
      //Date is at index 2
      tdC = tr[i].getElementsByTagName("td")[2];
      //Location is at index 3
      tdZ = tr[i].getElementsByTagName("td")[3];
      //stock is at index 5
      tdK = tr[i].getElementsByTagName("td")[5];

      if ((tdT.innerHTML.toLowerCase().indexOf(filterType) > -1 || filterType == "tous type") && (tdC.innerHTML.toLowerCase().indexOf(filterCat) > -1 || filterCat == "toutes catégories") && (tdZ.innerHTML.toLowerCase().indexOf(filterZone) > -1 || filterZone == "toutes zones") && (tdK.innerHTML.toLowerCase().indexOf(filterStock) > -1 || filterStock == "toutes unités")) {
        tr[i].style.display = "";
      }
      else {
        tr[i].style.display = "none";
      }
    }
    if ($('tr[style*="display: none"]').length == tr.length - 1) {
      document.querySelector('.search-result').style.display = "flex"
    } else {
      document.querySelector('.search-result').style.display = "none"
    }
  }
}

function filterTableInventoryMovements(table, elementType, elementCat, elementZone, elementMvt, column, all = false) {
  var input, filterType, filterCat, filterZone, filterMvt, table, tr, td, tdT, tdC, tdZ, cell, i, j;
  filterType = elementType
  filterCat = elementCat
  filterZone = elementZone
  filterMvt = elementMvt
  table = table;
  tr = table.getElementsByTagName("tr");

  if (all) {
    for (i = 1; i < tr.length; i++) {
      tr[i].style.display = "";
    }
  } else {
    for (i = 1; i < tr.length; i++) {
      td = tr[i].getElementsByTagName("td")[column];

      tdT = tr[i].getElementsByTagName("td")[0];
      tdC = tr[i].getElementsByTagName("td")[2];
      tdZ = tr[i].getElementsByTagName("td")[3];
      tdM = tr[i].getElementsByTagName("td")[1];
      if ((tdT.innerHTML.toLowerCase().indexOf(filterType) > -1 || filterType == "tous type") && (tdC.innerHTML.toLowerCase().indexOf(filterCat) > -1 || filterCat == "toutes catégories") && (tdZ.innerHTML.toLowerCase().indexOf(filterZone) > -1 || filterZone == "toutes zones") && (tdM.innerHTML.toLowerCase().indexOf(filterMvt) > -1 || filterMvt == "tous mouvements")) {
        tr[i].style.display = "";
      }
      else {
        tr[i].style.display = "none";
      }
    }
    if ($('tr[style*="display: none"]').length == tr.length - 1) {
      document.querySelector('.search-result').style.display = "flex"
    } else {
      document.querySelector('.search-result').style.display = "none"
    }
  }
}

function filterTableStockInventoryIndex(table, elementType, elementCat, elementZone, column, all = false) {
  var input, filterType, filterCat, filterZone, filterStock, table, tr, td, tdT, tdC, tdZ, tdK, cell, i, j;
  filterType = elementType
  filterCat = elementCat
  filterZone = elementZone
  table = table;
  tr = table.getElementsByTagName("tr");

  if (all) {
    for (i = 1; i < tr.length; i++) {
      tr[i].style.display = "";
    }
  } else {
    for (i = 1; i < tr.length; i++) {
      td = tr[i].getElementsByTagName("td")[column];
      //Type is at index 0
      tdT = tr[i].getElementsByTagName("td")[0];
      //Date is at index 2
      tdC = tr[i].getElementsByTagName("td")[2];
      //Location is at index 3
      tdZ = tr[i].getElementsByTagName("td")[3];

      if ((tdT.innerHTML.toLowerCase().indexOf(filterType) > -1 || filterType == "tous type") && (tdC.innerHTML.toLowerCase().indexOf(filterCat) > -1 || filterCat == "toutes catégories") && (tdZ.innerHTML.toLowerCase().indexOf(filterZone) > -1 || filterZone == "toutes zones")) {
        tr[i].style.display = "";
      }
      else {
        tr[i].style.display = "none";
      }
    }
    if ($('tr[style*="display: none"]').length == tr.length - 1) {
      document.querySelector('.search-result').style.display = "flex"
    } else {
      document.querySelector('.search-result').style.display = "none"
    }
  }
}

function filterTableMinStockIndex(table, elementCat, elementZone, column, all = false) {
  var filterCat, filterZone, table, tr, td, tdC, tdZ, i;
  filterCat = elementCat
  filterZone = elementZone
  table = table;
  tr = table.getElementsByTagName("tr");

  if (all) {
    for (i = 1; i < tr.length; i++) {
      tr[i].style.display = "";
    }
  } else {
    for (i = 1; i < tr.length; i++) {
      td = tr[i].getElementsByTagName("td")[column];
      //category is at index 2
      tdC = tr[i].getElementsByTagName("td")[2];
      //Location is at index 3
      tdZ = tr[i].getElementsByTagName("td")[3];

      if ((tdC.innerHTML.toLowerCase().indexOf(filterCat) > -1 || filterCat == "toutes catégories") && (tdZ.innerHTML.toLowerCase().indexOf(filterZone) > -1 || filterZone == "toutes zones")) {
        tr[i].style.display = "";
      }
      else {
        tr[i].style.display = "none";
      }
    }
    if ($('tr[style*="display: none"]').length == tr.length - 1) {
      document.querySelector('.search-result').style.display = "flex"
    } else {
      document.querySelector('.search-result').style.display = "none"
    }
  }
}


export { filterTableStockInventory, filterTableInventoryMovements, filterTableStockInventoryIndex, filterTableMinStockIndex };